import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import Loading from '../components/Loading';
import { useToast } from '../hooks/useToast';

const تسجيلالخروج = () => {
  const { logout } = useAuth();
  const { showToast, ToastContainer } = useToast();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await logout();
      showToast('تم تسجيل الخروج بنجاح', 'success');
      // Wait a bit before redirect
      setTimeout(() => {
        window.location.href = '/';
      }, 1500);
    } catch (error) {
      console.error('Logout error:', error);
      setIsLoggingOut(false);
      showToast('حدث خطأ أثناء تسجيل الخروج', 'error');
    }
  };

  if (isLoggingOut) {
    return <Loading />;
  }

  return (
    <div style={{
      width: '100vw',
      height: '100vh',
      backgroundColor: '#2B2F3F',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '40px',
      direction: 'rtl'
    }}>
      {/* Logo */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '12px'
      }}>
        <img 
          src="/Group 1000019470.png" 
          alt="Logo" 
          style={{
            width: '120px',
            height: 'auto',
            objectFit: 'contain',
            marginBottom: '12px'
          }}
        />
        <h1 style={{ 
          fontSize: '36px', 
          fontWeight: 700,
          color: '#FFFFFF',
          margin: 0,
          fontFamily: 'El Messiri, sans-serif'
        }}>
          لوحة التحكم
        </h1>
      </div>

      {/* Logout Card */}
      <div style={{
        backgroundColor: '#FFFFFF',
        borderRadius: '24px',
        padding: '48px',
        width: '100%',
        maxWidth: '500px',
        border: '1px solid rgba(233, 106, 58, 0.15)',
        boxShadow: '0px 8px 32px rgba(0, 0, 0, 0.12)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '32px',
        boxSizing: 'border-box'
      }}>
        {/* Icon */}
        <div style={{
          width: '100px',
          height: '100px',
          borderRadius: '50%',
          backgroundColor: 'rgba(233, 106, 58, 0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '3px solid rgba(233, 106, 58, 0.2)'
        }}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
            <path d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" stroke="#E96A3A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        {/* Text */}
        <div style={{ textAlign: 'center', width: '100%' }}>
          <h2 style={{
            fontFamily: 'El Messiri, sans-serif',
            fontSize: '26px',
            fontWeight: 700,
            color: '#2B2F3F',
            marginBottom: '12px',
            margin: '0 0 12px 0'
          }}>
            هل أنت متأكد من تسجيل الخروج؟
          </h2>
          <p style={{
            fontFamily: 'Cairo, sans-serif',
            fontSize: '15px',
            color: '#666A7A',
            lineHeight: '26px',
            margin: 0
          }}>
            سيتم إغلاق الجلسة الحالية والعودة إلى صفحة تسجيل الدخول
          </p>
        </div>

        {/* Buttons */}
        <div style={{
          display: 'flex',
          flexDirection: 'row-reverse',
          gap: '12px',
          width: '100%',
          justifyContent: 'center'
        }}>
          <button
            onClick={handleLogout}
            style={{
              padding: '14px 32px',
              borderRadius: '12px',
              border: 'none',
              backgroundColor: '#E96A3A',
              color: '#FFFFFF',
              fontFamily: 'El Messiri, sans-serif',
              fontSize: '14px',
              fontWeight: 600,
              cursor: 'pointer',
              minWidth: '140px',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#D85A2A';
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0px 4px 12px rgba(233, 106, 58, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#E96A3A';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            تسجيل الخروج
          </button>
          <button
            onClick={() => window.history.back()}
            style={{
              padding: '14px 32px',
              borderRadius: '12px',
              border: '1px solid rgba(102, 106, 122, 0.3)',
              backgroundColor: 'transparent',
              color: '#666A7A',
              fontFamily: 'El Messiri, sans-serif',
              fontSize: '14px',
              fontWeight: 600,
              cursor: 'pointer',
              minWidth: '140px',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(102, 106, 122, 0.05)';
              e.currentTarget.style.borderColor = 'rgba(102, 106, 122, 0.5)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.borderColor = 'rgba(102, 106, 122, 0.3)';
            }}
          >
            إلغاء
          </button>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default تسجيلالخروج;

